const globalState = {
  isLoading: false,
  userAccessList: null,
  userAccessIds: null,
  isExpanded: true,
  isTourOpen: false,
  tourConfirmationOpen: false,
  botomBorderColor: "#8D004C",
  toast: {
    isToastOpen: false,
    msgToast: null,
    typeStyle: null,
    displayTime: 5000,
  },
  listaEmpresas: null,
  companyName: null,
  companyId: null,
  userProfile: null,
  sucursalId: "",
  sucursalName: null,
  companySucursales: [],
  userData: {
    LoginSuccess: false,
    IsFirstLogin: false,
    AccessToken: null,
    RefreshToken: null,
    RUT: null,
    Email: null,
    FirstName: null,
    LastName: null,
    TempBD: false,
    DateLogIn: null,
  },
  preventNavigation: false,
  showGraph: false,
  // Listas de combos
  listaProfesiones: [],
  listaIsapres: [],
  listaAfp: [],
  listaRegion: [],
  listaEstadoCivil: [],
  listaBancos: [],
  listaTipoJornada: [],
  listaRubro: [],
  listaParentesco: [],
  listaComuna: [],
  listadoSucursales: [],
  listaSexos: [],
  listaNacionalidades: [],
  listaPueblosOriginarios: [],
  listaTiposCalle: [],
  listaClasificacionesAccidentes: [],
  listaMediosPrueba: [],
  listaTiposCuenta: [],
  listaTiposContrato: [],
  listaCategoriasOcupacionales: [],
  listaTiposIngreso: [],
  listaDirecciones: [],
  listaTipoDenuncias: [],
  listaTipoEmpresa: [],
  listaActividadEconomica: [],
  listaPropiedadEmpresa: [],
  listaTiposAccidenteTrayecto: [],
  listaTiposAccidente: [],
};

export default globalState;
